import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 11\" id=\"arrow-right\">\n    <path fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.613 9.845l4.98-4.533L1.612.837l-.65.6 4.31 3.875-4.31 3.933z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol